import { render, staticRenderFns } from "./PollQuestion.vue?vue&type=template&id=25d79da8&scoped=true"
import script from "./PollQuestion.vue?vue&type=script&lang=js"
export * from "./PollQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d79da8",
  null
  
)

export default component.exports